import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { money } from '../lib/format'
import { Button } from './ui'

export default function PaymentReturn({ reference, canceled, onConfirmed }: { reference: string; canceled: boolean; onConfirmed: () => void }) {
  const [result, setResult] = useState<{ status: string; balance: string; currency: string } | null>(null)
  const [error, setError] = useState('')
  const [retry, setRetry] = useState(0)
  const [checking, setChecking] = useState(true)
  useEffect(() => {
    let stopped = false
    let timer: ReturnType<typeof setTimeout> | undefined
    let attempts = 0
    async function check() {
      try {
        const status = await api.paymentStatus(reference)
        if (stopped) return
        setResult(status)
        setError('')
        if (status.status === 'succeeded') onConfirmed()
        if (status.status === 'pending' && !canceled && ++attempts < 20) {
          timer = setTimeout(check, 3000)
        } else setChecking(false)
      } catch (err) {
        if (!stopped) {
          setError(err instanceof Error ? err.message : 'Could not confirm payment yet.')
          setChecking(false)
        }
      }
    }
    void check()
    return () => { stopped = true; if (timer) clearTimeout(timer) }
  }, [reference, canceled, retry, onConfirmed])
  const paid = result?.status === 'succeeded'
  return <div className="card stack" role="status">
    <strong>{paid ? 'Payment confirmed — your wallet has been credited.' : canceled ? 'Checkout closed. Any completed payment will still be verified.' : result?.status === 'failed' || result?.status === 'canceled' ? 'Payment was not completed.' : checking ? 'Confirming your payment…' : 'Payment confirmation is pending.'}</strong>
    {paid ? <p>Wallet balance: {money(result.balance, result.currency ?? 'ETB')}</p> : <>
      <p className="tiny">{error || 'Credit appears only after the provider confirms payment. If you already paid, do not pay again.'}</p>
      {!checking && <Button onClick={() => { setChecking(true); setRetry(value => value + 1) }}>Check payment status</Button>}
    </>}
  </div>
}
